import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes,Switch } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Chat from './OpenAIMain/Chat';
import PythiaChat from './OpenAIMain/PythiaChat';
import LoginPage from './Login/Login';
import SignUp from './Login/SignUp';
import DeleteAccount from './Login/DeleteAccount';
import ReviewerChat from './OpenAIMain/ReviewerChat';
import EmailConfirmation from './Login/ConfirmationEmail';
import EndUserLicenseAgreement from './PrivacyPolicy/EndUserLicenseAgreement';
import TransparancyNote from './PrivacyPolicy/TransparancyNote';
import ScheduleA from './PrivacyPolicy/ScheduleA';
import ScheduleA1 from './PrivacyPolicy/ScheduleA1';
import HowToUseCopilot from './HowToUseCopilot';
import { AuthProvider } from './AuthContext';
import PrivateRoute from './PrivateRoute';
import ForgotPassword from './Login/ForgotPassword';
import ResetPassword from './Login/ResetPassword';
import Suggestion from './Suggestion';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<AuthProvider>
  <Router>
      <Routes>
        <Route path="/chat" element={<Chat />} />
        <Route path="/pythia-chat" element={<PythiaChat />} />
        <Route path="/end-user-license-agreement" element={<EndUserLicenseAgreement />} />
        <Route path="/transparancy-note" element={<TransparancyNote />} />
        <Route path="/schedule-a-terms-and-conditions" element={<ScheduleA />} />
        <Route path="/schedule-a1-data-processing-agreement" element={<ScheduleA1 />} />
        <Route path="/" element={<PythiaChat />} />
      </Routes>
  </Router>
</AuthProvider>
);
reportWebVitals();
